import { Fragment, useState } from "react";
import Address from "typedef/Address";
import CButton from "components/CButton";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Container, Typography, useTheme } from "@mui/material";
import CAddressAutocomplete from "components/CAddressAutocomplete";
import { usePrivateLabel } from "context/PrivateLabelContext/UsePrivateLabelContextProvider";

export default function CBanner() {
  const navigate = useNavigate();
  const location = useLocation();
  const [address, setAddress] = useState<Address | null>(null);
  const theme = useTheme();
  const { privateLabel } = usePrivateLabel();

  return (
    <Fragment>
      <Box
        display={"flex"}
        bgcolor={theme.palette.primary.dark}
        justifyContent={"center"}
        alignItems={{ xs: "start", md: "center" }}
        width={"100%"}
        height={"80vh"}
      >
        {privateLabel?.borrowerPortalBanner && (
          <img
            src={privateLabel.borrowerPortalBanner}
            alt="Hand holding phone with a holographic house on top of it."
            style={{
              width: "100%",
              height: "80vh",
              objectFit: "cover",
              objectPosition: "67%",
            }}
          />
        )}
        <Container
          maxWidth="lg"
          sx={{
            position: "absolute",
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Box
            width={{ md: "fit-content", xs: "100%" }}
            data-acsb-main={true}
            role="main"
          >
            <Typography
              mb={2}
              variant="h1"
              color={theme.palette.background.paper}
              mt={{ md: 0, xs: "1.5rem" }}
              fontFamily="Pro Display Semibold"
              fontSize={{ md: "4.5rem", xs: "2.6rem" }}
              role="heading"
              aria-level={1}
            >
              Tap your home <br /> equity in 1 minute
            </Typography>
            <CAddressAutocomplete
              address={address}
              noLabel
              setAddress={setAddress}
              placeholder="Start typing your home address and please select from the dropdown."
            />
            <Box mt={2}>
              <CButton
                variant="contained"
                onClick={() =>
                  navigate(`/signup${location.search}`, {
                    state: address,
                    replace: true,
                  })
                }
                sx={{
                  mt: 3,
                  width: { md: "auto", xs: "100%" },
                  "-webkit-box-shadow": "0px 5px 28px -3px rgba(0,0,0,0.58)",
                  boxShadow: "0px 5px 28px -3px rgba(0,0,0,0.58)",
                }}
              >
                Check My Rate
              </CButton>
            </Box>
          </Box>
        </Container>
      </Box>
      {/* @ts-expect-error */}
      <access-widget-ui
        data-acsb="skipLinks"
        class="notranslate"
        // @ts-expect-error
      ></access-widget-ui>
    </Fragment>
  );
}
